export type ProtocolOrder = { steps: {id:string;text:string}[]; initialOrder:string[] };

export function protocolOrderErrors(value:ProtocolOrder):string[] {
  if(!value || !Array.isArray(value.steps) || !Array.isArray(value.initialOrder)) return ['Jeu de protocole invalide.'];
  const ids=value.steps.map(s=>s?.id);
  if(ids.length<3 || ids.length>12 || ids.some(id=>typeof id!=='string'||!id) || new Set(ids).size!==ids.length || value.steps.some(s=>typeof s?.text!=='string'||!s.text.trim()))return ['Étapes du protocole invalides.'];
  if(value.initialOrder.length!==ids.length || new Set(value.initialOrder).size!==ids.length || value.initialOrder.some(id=>!ids.includes(id)))return ['Le jeu doit contenir chaque étape exactement une fois.'];
  if(value.initialOrder.every((id,i)=>id===ids[i]))return ['Les étapes doivent être proposées dans le désordre.'];
  return [];
}

export function checkProtocolOrder(config:ProtocolOrder, selected:string[]) {
  if(protocolOrderErrors(config).length || selected.length!==config.steps.length || new Set(selected).size!==selected.length)return {correct:false,firstError:0};
  const firstError=config.steps.findIndex((s,i)=>s.id!==selected[i]);
  return {correct:firstError===-1,firstError};
}

export function protocolText(config:ProtocolOrder, selected:string[]) {
  return selected.map((id,i)=>`${i+1}. ${config.steps.find(s=>s.id===id)?.text??''}`).join('\n');
}
